// src/services/authService.ts
import agent from "../api/agent";
import { ApiResponse } from "../models/ApiResponse";
import { LoginRequest } from "../models/LoginRequest";
import { toast } from "react-toastify";
import { LoginResponse } from "../models/LoginResponse";
import { store } from "../stores/store";
import { USER_TYPES } from "../api/constants";

export interface User {
  id: number;
  name: string;
  email: string;
  mobile: string | null;
}

export const handleLogin = async (
  credentials: LoginRequest,
  onSuccess: () => void
) => {
  try {
    const response: ApiResponse<LoginResponse> = await agent.User.login(
      credentials
    );

    if (response.status === "error") {
      throw new Error(response.message || "Login failed");
    }
    if (response.data.user.role.name === USER_TYPES.SUPER_ADMIN) {
      throw new Error(
        "Super Admins are not allowed to login from this interface"
      );
    }

    store.userStore.setUser(response.data.user, response.data.token);

    toast.success("Login successful");
    onSuccess();

  } catch (error: any) {
    if (Array.isArray(error)) {
      error.forEach((err) => toast.error(err));
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error("Login failed");
    }
    throw error;
  }
};

export const getProfile = async () => {
  return await agent.User.getProfile();
}
